import { CellContext } from "@tanstack/react-table"
import classNames from "classnames"

import { ApiTypes, UITypes } from "types"

import styles from "./index.module.scss"

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const getStatusLabel = (type: string): string => {
  switch (type) {
    case "canceled":
      return "Canceled"

    case "confirmed":
      return "Confirmed"

    case "denied":
      return "Denied"

    case "archived":
      return "Fulfilled"

    case "new":
      return "New"

    case "packed":
      return "Packed"

    case "pending":
      return "Pending"

    case "shipping":
      return "Shipping"

    default:
      return type
  }
}

export const StatusOfOrderNew = ({ cell }: Props) => {
  const items = cell.row.original.rowSettings.item as ApiTypes.Model.OrderNewItem[] | undefined
  const isExpanded = cell.row.getIsExpanded()

  if (!items || items.length === 0 || (isExpanded && items.length > 1)) {
    return null
  }

  const statuses = items.map(item => item.status).filter(Boolean)

  if (statuses.length === 0) {
    return null
  }

  return (
    <div className={styles.statusContainer}>
      {statuses.map((status, index) => {
        const type = String(status)
        const label = getStatusLabel(type)

        return (
          <span
            key={`${status}-${index}`}
            className={classNames(styles.orderStatus, {
              [styles[type]]: type ? true : false,
            })}
          >
            {label}
          </span>
        )
      })}
    </div>
  )
}
